<template>
  <div class="d-flex">
    <div :class="classDec" @click="decrease">ー</div>
    <div :class="classNum">{{ count }}</div>
    <div :class="classInc" @click="increase">+</div>
  </div>
</template>

<script>
export default {
  name: 'TkStepper',
  components: {},
  props: {
    step: {
      type: Number,
      required: false,
      default: 1,
    },
    maxValue: {
      type: Number,
      required: false,
      default: 9,
    },
    minValue: {
      type: Number,
      required: false,
      default: 0,
    },
    classDec: {
      type: Array,
      required: false,
      default() {
        return ['tourHotelPeople-dec']
      },
    },
    classInc: {
      type: Array,
      required: false,
      default() {
        return ['tourHotelPeople-inc']
      },
    },
    classNum: {
      type: Array,
      required: false,
      default() {
        return ['tourHotelPeople-num']
      },
    },
    defaultValue: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data: function () {
    return {
      count: this.defaultValue,
    }
  },
  watch: {
    count: function (value) {
      this.$emit('change', { value })
    },
  },
  methods: {
    decrease() {
      const count =
        Number(this.count) - Number(this.step) < this.minValue
          ? this.minValue
          : Number(this.count) - Number(this.step)
      this.count = count
    },
    increase() {
      const count =
        Number(this.count) + Number(this.step) > this.maxValue
          ? this.maxValue
          : Number(this.count) + Number(this.step)
      this.count = count
    },
  },
}
</script>
